import fetchApi from "../../../utils/api/fetchApi";
import { CommonProps, defaultRtn, FileValidityPeriodStringType, RtnType } from "../../../utilsTs/declareTypes";

/** 文件apis */
const filesApis = async () => { };

/** 文件上传选项 */
export declare interface UploadOptions extends Partial<Pick<CommonProps, 'defaultService'>> {
    /** 服务地址，(服务地址、文件服务器id，二选一)，例如 http://localHost:3009/test/file/service */
    serverUrl?: string;
    /** 文件服务器id（必需传入defaultService），(服务地址、文件服务器id，二选一) */
    filesServerId?: string;
    /** 服务id */
    serviceId: string;
    /** 文件组id */
    filesGroupId: string;
    /** 文件存的子目录 */
    subdirectory?: string;
    /** 文件有效期id，默认：permanent */
    fileValidityPeriodId?: FileValidityPeriodStringType;
    /** 扩展数据 */
    extendedData?: Record<string, string | number | boolean>;
    /** 文件上传后的回调方法，返回格式RtnType: { success: boolean, data: any } */
    callback?: (result: RtnType<any>) => void;
};

/** 文件上传返回 */
export declare interface UploadReturn {
    /** 服务id */
    serviceId: string;
    /** 上传配置 */
    config: any;
};

/**
 * 文件上传
 * @param options 选项
 * @returns 
 */
filesApis.upload = async (options: UploadOptions): Promise<RtnType<UploadReturn>> => {
    const rtn = defaultRtn<UploadReturn>();
    try {
        let { defaultService, serverUrl, filesServerId, serviceId, filesGroupId,
            subdirectory, extendedData, callback, fileValidityPeriodId = 'permanent' } = options;

        // ========== 参数校验：serverUrl 与 filesServerId 必须提供其一 ==========
        // 两者都没有，直接返回错误
        if (!serverUrl && !filesServerId) {
            rtn.success = false;
            rtn.message = '参数错误：serverUrl 与 filesServerId 必须传入其中之一';
            return rtn;
        }
        // 传了 filesServerId 但未传 defaultService，无法获取服务地址
        if (!serverUrl && filesServerId && !defaultService) {
            rtn.success = false;
            rtn.message = '参数错误：使用 filesServerId 时必须同时传入 defaultService';
            return rtn;
        }
        // ========== 参数校验结束 ==========

        if (typeof serverUrl === 'undefined') {
            //获取上传服务地址
            const fetchRes = await fetchApi.GET(defaultService!,
                {
                    apiId: 'filesServer',
                    apiExtend: 'getDefaultServer',
                    apiVariable: filesServerId,
                    apiData: {
                        urlModel: 'apiServiceUrl'
                    }
                });
            if (fetchRes.success === true) {
                serverUrl = fetchRes.data;
            } else {
                rtn.success = false;
                rtn.message = fetchRes.message || '获取上传服务地址失败';
                return rtn;
            }
        }
        /** 上传配置 */
        const config = {
            name: 'file',
            action: serverUrl,
            headers: {
                authorization: `Bearer ${localStorage.getItem('token') as string}`,
                apiId: 'files',
                apiExtend: 'uploadSingleFile',
                filesGroupId,
                subdirectory,
                serviceId,
                fileValidityPeriodId,
                ...extendedData
            },
            async onChange(info: any) {
                if (info.file.status !== 'uploading') {
                }
                if (info.file.status === 'done') {
                    if (info.file.response.success) {
                        if (callback) {
                            callback(
                                {
                                    success: true,
                                    data: {
                                        upload: info.file.response.data,
                                        filesGroupId
                                    }
                                }
                            );
                        }
                    }
                    else {
                        if (callback) {
                            callback({
                                success: false,
                                message: info.file.response.message
                            })
                        }
                    }
                } else if (info.file.status === 'error') {
                    if (callback) {
                        callback({
                            success: false,
                            message: info.file.response.message
                        })
                    }
                }
            },
        }
        rtn.success = true;
        rtn.data = {
            serviceId,
            config
        };
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `${rtn.message}${message}`;
        }
    }
    return rtn;
};

/** 文件apis */
export default filesApis;